import { render } from "./PhotoCard.vue?vue&type=template&id=33264cd2&scoped=true"
import script from "./PhotoCard.vue?vue&type=script&lang=js"
export * from "./PhotoCard.vue?vue&type=script&lang=js"

import "./PhotoCard.vue?vue&type=style&index=0&id=33264cd2&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33264cd2"]])

export default __exports__